import React from 'react';
import { ShimmerThumbnail } from "react-shimmer-effects";

const AccountSummaryLoader = () => {
  return (
    <>
      <div><ShimmerThumbnail height={33} className="rounded-5 mb-0" /></div>
      <div><ShimmerThumbnail height={14} className="rounded-5 mb-0" /></div>
    </>
  );
};

export default AccountSummaryLoader;
